import React, { useState, useContext, useCallback } from 'react';
import './endcap.scss';
import { Tab, Tabs } from '@thd-olt-component-react/core-ui';
import { CategoryTabsPropType, CategoryTabsDefaultPropType } from './Helper';

const CategoryTabs = ({
  categories,
  nameOfEventAttribute = 'Model2',
  handleTabClick,
}) => {
  const [value, setValue] = useState(0);
  const onChange = ({ index }) => {
    setValue(index);
  };
  const changeActiveIndex = useCallback((newIndex) => {
    setValue(newIndex);
  }, []);

  return (
    <Tabs
      gridStyle
      parentId="digital-endcap-tabs"
      value={value}
      onChange={onChange}
    >
      {(categories || []).map((category, categoryIndex) => (
        <Tab
          key={categoryIndex}
          label={category.category}
          value={categoryIndex}
          onClick={(ev) => handleTabClick(
            ev,
            categoryIndex,
            category.nValue,
            nameOfEventAttribute,
            changeActiveIndex
          )}
        />
      ))}
    </Tabs>
  );
};

CategoryTabs.propTypes = CategoryTabsPropType;
CategoryTabs.defaultProps = CategoryTabsDefaultPropType;

export { CategoryTabs };
